import React from 'react';
import SectionHeader from '../SectionHeader';
import NavigationLink from '../NavigationLink';
import Route from '../../../../enums/route';
import { KPMGAdminsLinkIcon, KPMGClientsLinkIcon, KPMGCompaniesLinkIcon, KPMGUsersLinkIcon } from '../../../../assets/icons';
import { automationIds } from '../../../../constants/automationIds';
import AccessPolicy from '../../../../enums/accessPolicy';
const AdministrationSection = () => (<>
    <SectionHeader title='SIDER.HEADER.ADMINISTRATION'/>
  
    <NavigationLink to={Route.Companies} icon={<KPMGCompaniesLinkIcon />} title='SIDER.LINK.COMPANIES' automationId={automationIds.NAV_LINK.COMPANIES} policy={{ id: AccessPolicy.ViewCompanies }}/>
    <NavigationLink to={Route.Users} icon={<KPMGUsersLinkIcon />} title='SIDER.LINK.USERS' automationId={automationIds.NAV_LINK.USERS} policy={{ id: AccessPolicy.ViewUsers }}/>
    <NavigationLink to={Route.Clients} icon={<KPMGClientsLinkIcon />} title='SIDER.LINK.CLIENTS' automationId={automationIds.NAV_LINK.CLIENTS} policy={{ id: AccessPolicy.ViewClientAdmins }}/>
    <NavigationLink to={Route.Admins} icon={<KPMGAdminsLinkIcon />} title='SIDER.LINK.ADMINS' automationId={automationIds.NAV_LINK.ADMINS} policy={{ id: AccessPolicy.ViewKpmgAdmins }}/>
  </>);
export default AdministrationSection;
